// extracted by mini-css-extract-plugin
module.exports = {"nestedNav":"AppLayout_nestedNav__PDHZo","nestedList":"AppLayout_nestedList__ABqsm","activeUserRole":"AppLayout_activeUserRole__1NOLU"};